<template>
  <div ref="page">
    <Grid variant="default" class="grid">
      <PageThemeBar :centered="true" overview-label="Voorpagina" />
    </Grid>
    <NuxtPage />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="postcss">
.grid {
  margin-top: 12px !important;
  margin-bottom: 16px !important;

  @media (--md-viewport) {
    margin-top: 14px !important;
    margin-bottom: 24px !important;
  }

  @media (--lg-viewport) {
    margin-bottom: 32px !important;
  }
}
</style>
